import { useState } from "react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { ManageSubscriptionDialog } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWhitelabelCustomization from "common/hooks/useWhitelabelCustomization";

export default function RentAccountsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { rental_subscription: rentedSubscription } =
    useSelectedWorkspaceContext();
  const { whitelabelCustomization } = useWhitelabelCustomization();

  if (!whitelabelCustomization) {
    return (
      <RestrictedComponent visibleForPermissions={["billing_full"]}>
        <Button onClick={() => setIsOpen(true)} variant="secondary-purple">
          Rent accounts
        </Button>

        <ManageSubscriptionDialog
          plan="avatar"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          fixedPricingPeriodInfo={
            rentedSubscription
              ? {
                  period: rentedSubscription.item_price.period,
                  period_unit: rentedSubscription.item_price.period_unit,
                }
              : { period: 1, period_unit: "month" }
          }
        />
      </RestrictedComponent>
    );
  }
}
